export function chunk<T>(a:Array<T>, size:number): Array<Array<T>>{
    let result: Array<Array<T>> = []
    for(let i=0; i<a.length;i+=size){
        result.push(a.slice(i, i+size))
    }
    return result
}